import Search from './Search';
import IconSearch from './icon-search';

Search.Icon = IconSearch;

export default Search;
